module.exports = __webpack_public_path__ + "static/img/footer5.5855ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/footer5.png
// module id = psoG
// module chunks = 1